import { useCallback, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Descriptions, Divider, Flex, Input, Space } from "antd";
import { EyeInvisibleOutlined, EyeTwoTone } from '@ant-design/icons';
import { BaseContainer } from "components/containers";
import { FillButton } from "components/elements";
import { BaseSection } from "components/layouts";
import { getHqAPI, putHqAPI } from "api/hq";
import { useLocalStorage } from "hooks/useLocalStorage";
import { objToLowerCase } from "utils/utils";
import { getCheckEmailAPI } from "api/common";

export default function AccountInfo () {
  const navigate = useNavigate();
  const [userInfo, setUserInfo] = useLocalStorage('persist:user', null);

  const [info, setInfo] = useState({});
  const [oldEmail, setOldEmail] = useState('');

  const fnCheckEmail = async () => {
    const params = {
      email: info?.email
    }
    await getCheckEmailAPI(params)
    .then(res => {
      const { email_cnt } = res?.data;
      if (email_cnt < 1 || oldEmail === info?.email) alert('사용 가능한 이메일입니다.');
      else if (email_cnt >= 1 && (oldEmail !== info?.email)) alert('다른 이메일을 입력해주세요.');
    })
    .catch(err => {
      console.error(err);
    })
  }
  
  // 정보 수정 전 유효성 체크
  const fnCheckValid = () => {
    const { hq_name, email, cell_phone, home_phone, pw, pwCheck } = info;
  
    if (!hq_name || !home_phone || !cell_phone) {
      alert('정보를 정확히 입력해주세요.');
    } else {
      if (pw && (pw !== pwCheck)) alert('비밀번호를 확인해주세요.');
      else fnUpdateInfo();
    }
  }

  const fnHandleInfo = useCallback((value) => {
    setInfo(info => ({
      ...info,
      ...value
    }))
  }, []);

  // 내 정보 가져오기
  const fnGetHq = async () => {
    const idx = userInfo?.user_idx;
    await getHqAPI(idx)
    .then(res => {
      const { data_info } = res?.data;
      setInfo({
        ...objToLowerCase(data_info)
      })
      setOldEmail(data_info?.EMAIL);
    })
    .catch(err => {
      console.error(err);
    })
  }

  // 내 정보 수정
  const fnUpdateInfo = async() => {
    const idx = userInfo?.user_idx;
    const data = {
      hq_name: info?.hq_name,
      cell_phone: info?.cell_phone,
      home_phone: info?.home_phone,
      email: info?.email,
      ...(info?.pw !== '' && { pw: info?.pw })
    }
    await putHqAPI({ idx, data })
    .then(res => {
      if (res?.status === 200) {
        alert('저장되었습니다.');
        navigate('/');
      } else alert('다시 시도해주세요.');
    })
    .catch(err => {
      console.error(err);
    })
  }

  useEffect(() => {
    fnGetHq();
  }, [])

    const infoItems = [
    {
      key: '1',
      label: <span className='text-require'>관리자명</span>,
      span: 2,
      children: <Input value={info?.hq_name} onChange={(e) => fnHandleInfo({ hq_name: e.target.value })} />
    }, {
      key: '2',
      label: <span className='text-require'>휴대폰번호</span>,
      span: 2,
      children: <Input value={info?.cell_phone} onChange={(e) => fnHandleInfo({ cell_phone: e.target.value })} />
    }, {
      key: '3',
      label: <span className='text-require'>연락처</span>,
      span: 2,
      children: <Input value={info?.home_phone} onChange={(e) => fnHandleInfo({ home_phone: e.target.value })} />
    }, {
      key: '4',
      label: '관리자 이메일',
      span: 2,
      children: (
        <Space>
          <Input 
            value={info?.email} 
            onChange={(e) => fnHandleInfo({ email: e.target.value })} 
          />
          <FillButton 
            label='중복체크' 
            backgroundColor={'var(--color-gray03)'}
            onClick={fnCheckEmail}
          />
        </Space>
      )
    }, {
      key: '5',
      label: '비밀번호',
      span: 2,
      children: <Space direction="vertical" style={{width:'100%'}}>
                  <Input.Password 
                    defaultValue={''}
                    style={{width:'100%'}}
                    placeholder="변경할 비밀번호를 입력해주세요."
                    iconRender={(visible) => (visible ? <EyeTwoTone /> : <EyeInvisibleOutlined />)}
                    onChange={(e) => fnHandleInfo({ pw: e.target.value })}
                  />
                  <Flex>※ 변경을 원할경우만 입력하시면 됩니다</Flex>
                </Space>
    }, {
      key: '6',
      label: '비밀번호 확인',
      span: 2,
      children: <Space direction="vertical" style={{width:'100%'}}>
                  <Input.Password
                    defaultValue={''}
                    style={{width:'100%'}}
                    placeholder="변경할 비밀번호를 입력해주세요."
                    iconRender={(visible) => (visible ? <EyeTwoTone /> : <EyeInvisibleOutlined />)}
                    onChange={(e) => fnHandleInfo({ pwCheck: e.target.value })}
                  />
                  <Flex>※ 변경을 원할경우만 입력하시면 됩니다</Flex>
                </Space>
    }, 
  ]

  return (
    <BaseSection>
      <BaseContainer>
        <Descriptions 
          bordered
          items={infoItems}
        />
        <Divider className="divider" />
        <Flex justify={'right'}>
          <FillButton label="내정보 수정하기" onClick={fnCheckValid} />
        </Flex>
      </BaseContainer>
    </BaseSection>
  )
}